import React, { Component } from "react";
import { Form, Cascader } from 'antd';
import { setCascadeOptions, getCustomizeOptionInfo } from '@/fetch/api/personal';
import './index.less';
export default class CascaderContainer extends Component {
  state = {
    options: [],
    popupVisible: false // 下拉显示

  };

  async componentDidMount() {
    let res = [];

    if (this.props.type && this.props.type === 'info') {
      res = await this.initDataInfo({
        filedId: this.props.data.fieldId,
        pid: 0
      });
    } else {
      res = await this.initData({
        field_id: this.props.data.fieldId,
        level: 1
      });
    }

    this.setState({
      options: res
    }, () => {
      if (this.props.data.value) {
        let arr = this.props.data.value.split(",").map(value => Number(value));
        arr.pop();
        this.formatData(arr);
      }
    });
  }

  initData = async param => {
    // 获取代报考级联数据
    let arr = [];

    try {
      let res = await setCascadeOptions(param);

      if (res.code === '1') {
        arr = res.data.map(elem => ({
          value: elem.id,
          label: elem.content,
          isLeaf: false
        }));
        return arr;
      }
    } catch (e) {
      return [];
    }
  };
  initDataInfo = async param => {
    // 获取完善信息级联数据
    let arr = [];

    try {
      let res = await getCustomizeOptionInfo(param);

      if (res.code === '1') {
        arr = res.data.map(elem => ({
          value: elem.id,
          label: elem.content,
          isLeaf: false
        }));
        return arr;
      }
    } catch (e) {
      return [];
    }
  };
  formatData = async arr => {
    let obj = {};
    let res = await Promise.all(arr.map(async value => {
      let data = [];

      if (this.props.type && this.props.type === 'info') {
        data = await this.initDataInfo({
          filedId: this.props.data.fieldId,
          pid: value
        });
      } else {
        data = await this.initData({
          field_id: this.props.data.fieldId,
          id: value
        });
      }

      obj[value] = data;
      return value;
    }));
    let cache = this.state.options;

    if (cache.length) {
      for (let item of res) {
        let children = obj[item];
        let parent = cache.find(elem => elem.value == item);

        if (parent) {
          parent.children = children;
        }

        cache = children;
      }
    }

    this.setState({
      options: [...this.state.options]
    });
  };
  handleLoadData = async selectedOptions => {
    // 点击加载
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    let res = [];

    if (this.props.type && this.props.type === 'info') {
      res = await this.initDataInfo({
        filedId: this.props.data.fieldId,
        pid: targetOption.value
      });
    } else {
      res = await this.initData({
        field_id: this.props.data.fieldId,
        id: targetOption.value
      });
    }

    targetOption.loading = false;
    targetOption.isLeaf = true;
    let filterRes = res && res.length ? res.filter(value => value.label !== '') : [];

    if (filterRes.length) {
      targetOption.children = filterRes;
    } else {
      this.setState({
        popupVisible: false
      });
    }

    this.setState({
      options: [...this.state.options]
    });
  };
  handlePopupVisible = value => {
    // 控制级联
    this.setState({
      popupVisible: value
    });
  };

  render() {
    const {
      data,
      sceneCode
    } = this.props;
    const {
      getFieldDecorator
    } = this.props.form;
    const defaultValue = this.props.data.value ? this.props.data.value.split(",").map(value => Number(value)) : [];
    const conCascader = getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || [];

          if (data.required && !val.length) {
            callback('必填项，请输入相关信息');
            return;
          }

          callback();
        }
      }],
      initialValue: defaultValue
    })(<Cascader data-inspector-line="152" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\CascaderContainer\\index.jsx" getPopupContainer={triggerNode => triggerNode.parentElement} placeholder={sceneCode == '1' && data.fieldTip ? data.fieldTip : '请选择'} options={this.state.options} loadData={this.handleLoadData} changeOnSelect popupVisible={this.state.popupVisible} onPopupVisibleChange={this.handlePopupVisible} disabled={data.frontUpdateFlag === 1} />);
    return <div data-inspector-line="164" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\CascaderContainer\\index.jsx" className="detail-sel-cascader detail-sel-wrap">
        <Form.Item data-inspector-line="165" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\CascaderContainer\\index.jsx">
          {conCascader}
        </Form.Item>
      </div>;
  }

}